module.exports = __webpack_public_path__ + "img/paypal.089c3b02.svg";